module.exports = __webpack_public_path__ + "static/media/ecos_Logo_Stuttgart_CMYK.a52f0118.png";